import api from './api';

const partnerServiceService = {
  // Service Categories
  getServiceCategories: async () => {
    try {
      const response = await api.get('/partners/service-categories/');
      // Handle paginated response
      const data = response.data.results || response.data;
      return { success: true, data: data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to fetch service categories'
      };
    }
  },

  // Services CRUD
  getServices: async () => {
    try {
      const response = await api.get('/services/partner/services/');
      // Handle paginated response
      const data = response.data.results || response.data;
      return { success: true, data: data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to fetch services'
      };
    }
  },

  getServiceById: async (serviceId) => {
    try {
      const response = await api.get(`/services/partner/services/${serviceId}/`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to fetch service details'
      };
    }
  },

  createService: async (data) => {
    try {
      const response = await api.post('/services/partner/services/', data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to create service'
      };
    }
  },

  updateService: async (serviceId, data) => {
    try {
      const response = await api.patch(`/services/partner/services/${serviceId}/`, data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to update service'
      };
    }
  },

  deleteService: async (serviceId) => {
    try {
      await api.delete(`/services/partner/services/${serviceId}/`);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to delete service'
      };
    }
  },

  // Availability Management
  addAvailability: async (serviceId, data) => {
    try {
      const response = await api.post(`/services/partner/services/${serviceId}/availability/`, data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to add availability'
      };
    }
  },

  updateAvailability: async (serviceId, availabilityId, data) => {
    try {
      const response = await api.patch(`/services/partner/services/${serviceId}/availability/${availabilityId}/`, data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to update availability'
      };
    }
  },

  deleteAvailability: async (serviceId, availabilityId) => {
    try {
      await api.delete(`/services/partner/services/${serviceId}/availability/${availabilityId}/`);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to delete availability'
      };
    }
  },

  copyAvailability: async (serviceId, sourceDay, targetDays) => {
    try {
      const response = await api.post(`/services/partner/services/${serviceId}/availability/copy/`, {
        source_day: sourceDay,
        target_days: targetDays
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.response?.data?.message || error.message || 'Failed to copy availability'
      };
    }
  },

  // Holidays Management
  addHoliday: async (serviceId, data) => {
    try {
      const response = await api.post(`/services/partner/services/${serviceId}/holidays/`, data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to add holiday'
      };
    }
  },

  deleteHoliday: async (serviceId, holidayId) => {
    try {
      await api.delete(`/services/partner/services/${serviceId}/holidays/${holidayId}/`);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to delete holiday'
      };
    }
  }
};

export default partnerServiceService;
